<template>
  <div >
      <div class="col-md-12" >  
        <div class="row">

          <div :v-loading="loadingApplications" element-loading-spinner="qc-spinner" class="col-md-12 card" :data-background-color="'info'">
            <div class="card-header">
                <h4 class="card-title">You have open applications awaiting submission.</h4>
            </div>
            <div class="card-content col-md-12" style="float:none">
              <div>
                <p>Please complete your application(s) to the following organisations. You can include existing verifications from your wallet in your application, or submit new ones.</p>
              </div>
            </div>
          </div>

          
          <div v-for="application in applications" :key="application.id" :v-loading="loadingApplications" element-loading-spinner="qc-spinner" class="col-md-12 card" >
            <div class="card-content col-md-12" style="float:none">
              <div>
                <p><img v-if="application" class="partnerLogoLeft" :src="application.logo" /> Application to {{application.owner.name}} <button  @click="$router.push('/application/' + application.id + '/start')" type="button" class="btn btn-wd btn-fill pull-right"><i class="fa fa-play" style="color: inherit"></i> Start</button></p>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
  
  export default {
    name: "open-applications",
    props: {
    },
    data () {
      return {
        loadingApplications: false,
        applications: null
      }
    },
    mounted() {
      this.loadingApplications = true
      this.$api.getApplicationHistory({"status":["OPEN"]})
        .then(response => {
            if(response.data.content.length == 1) {
              this.$router.push('/application/' + response.data.content[0].id + '/start')
            }
            this.applications = response.data.content
            this.loadingApplications = false
          }).catch(error => {
            console.log(error)
            this.loadingApplications = false
          })
    },
    computed: {

    },
    methods: {

    }
  }
</script>

<style>
.partnerLogoLeft {
  max-width: 20% !important; 
  max-height: 70px !important; 
  object-fit: contain;
  margin-top: 10px;
}
</style>